<template>
  <div class="s-setting-container no-border">
    <div class="main-header">
      <div>
        Integrations
        <div class="sub-header">
          Enhance your experience. Seamlessly connect your tools with the SmartAC.com platform.
        </div>
      </div>
    </div>
    <div class="main-container">
      <IntegrationCard
        title="Slack"
        body="Review and action service requests, smartops recommendations, and more right from your slack."
        :connected="isSlackConnected"
        :screen="screen"
        :show-connect="!isSlackConnected"
        :toggleConnect="() => toggleActionModal(true, 'slack-connect', {})"
        :toggleEdit="editSlackIntegration"
      >
        <template #icon>
          <img
            class="slack-img"
            src="@shared/assets/img/general/slack.png"
            alt="slack"
          >
        </template>
      </IntegrationCard>
      <IntegrationCard
        title="Single Sign-On"
        body="Delegate user authentication to your corporate identity provider."
        :connected="!!iprovider.corpId"
        :screen="screen"
        :show-connect="!iprovider.corpId"
        :toggleConnect="() => toggleActionModal(true, 'sso-connect', {})"
        :toggleEdit="() => toggleActionModal(true, 'sso-connect', {})"
      >
        <template #icon>
          <span class="icon-Lock-Locked sac__font-30" />
        </template>
      </IntegrationCard>
      <IntegrationCard
        title="ServiceTitan"
        body="Two way sync all your service requests, opportunities, and job information to eliminate double entry."
        :connected="titanIntegrationStatus === 'complete'"
        :screen="screen"
        :pending="titanIntegrationStatus === 'pending'"
        :show-connect="titanIntegrationStatus === 'init'"
        :toggleConnect="() => toggleActionModal(true, 'titan-connect')"
        :toggleEdit="editTitanSettings"
      >
        <template #icon>
          <img
            class="st-img"
            src="https://smac-images.s3.us-west-2.amazonaws.com/email/service-titan-logo.png"
            alt="Service Titan"
          >
        </template>
      </IntegrationCard>
    </div>
    <IntegrationsModal
      :toggle="toggleActionModal"
      :update="update"
      :partnerSettings="partnerSettings"
      :changeStateValue="changeStateValue"
      :iprovider="iprovider"
    />
  </div>
</template>

<script>
import IntegrationCard from './IntegrationCard.vue';
import IntegrationsModal from './modals/IntegrationsModal.vue';

export default {
  name: 'IntegrationsSection',
  components: {
    IntegrationCard,
    IntegrationsModal,
  },
  props: {
    update: Function,
    partnerSettings: Object,
    currentCorporation: Object,
    changeStateValue: Function,
    screen: String,
  },
  data() {
    return {
      address: {},
      iprovider: {},
    };
  },
  computed: {
    isSlackConnected() {
      const {
        SLACK_ACCESS_TOKEN = '',
      } = this.partnerSettings;
      return SLACK_ACCESS_TOKEN !== '';
    },
    titanIntegrationStatus() {
      const {
        ST_TENANT_ID = '',
        ST_SETUP_COMPLETE = false,
      } = this.partnerSettings;
      if (ST_TENANT_ID !== '' && ST_SETUP_COMPLETE) {
        return 'complete';
      }
      if (ST_TENANT_ID !== '') {
        return 'pending';
      }
      return 'init';
    },
  },
  watch: {
    async showActionModal(nv) {
      if (nv === false) {
        const res = await this.$store.dispatch('getIdentityProvider', this.currentCorporation.id);
        if (res) {
          this.iprovider = res;
        }
      }
    },
  },
  async mounted() {
    const res = await this.$store.dispatch('getIdentityProvider', this.currentCorporation.id);
    if (res) {
      this.iprovider = res;
    }
  },
  methods: {
    handleChange(field, value) {
      if (field === 'address') {
        Object.keys(value).forEach((k) => {
          if (this[k] !== undefined) {
            this[k] = value[k];
          }
        });
      } else {
        this[field] = value;
      }
    },
    toggleActionModal(show, view) {
      const changes = [{
        field: 'showIntActionModal',
        value: show,
      }, {
        field: 'actionIntModalView',
        value: view,
      }];

      this.$store.dispatch('changeSettingValues', changes);
    },
    editSlackIntegration() {
      this.toggleActionModal(true, 'edit-slack-integration', null);
    },
    editTitanSettings() {
      const {
        ST_SETUP_COMPLETE: isSetupComplete,
      } = this.partnerSettings;
      if (isSetupComplete) {
        this.toggleActionModal(true, 'titan-edit-integration', {});
      } else {
        this.toggleActionModal(true, 'titan-cred', null);
      }
    },
  },
};
</script>
